// src/utils/functions.utils.js

/** Commonly used project functions **/

// Import the codeSetMapping from our centralized location
import { codeSetMapping } from '@/containers/Codes';


// Takes 186000 and turns it into 1,860.00. Intl library is better, but 100 factor is not.
// export const formatPrice = (digit) => (Number(digit)/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');


// Capitalises the first word in a sentence
export const capitalize = (word) => {
  return word ? word.charAt(0).toUpperCase() + word.slice(1) : '';
}


export function splitAndCapitalize(keyStr){
  const wordsInKey = keyStr.trim().split('-');
  for (let i=0; i<wordsInKey.length; ++i){
    wordsInKey[i] = wordsInKey[i].replace(/^\w/, (c) => c.toUpperCase());
  }
  return wordsInKey.join(' ');
}


// Checks if value is between a min and a max
export const isBetween = (min, val, max) => min <= val && val <= max;


// AND search. Checks if target is inside of arr. E.g.: red and blue and yellow
export const containsAllTargetElements = (arr, target) => target.every(v => arr.includes(v));


// OR search. Check if any of the values are inside the array. E.g.: modern or classic or rustic
export const containsAnyTargetElement = (arr, target) => target.some(v => arr.includes(v));


// ONLY search. Arrays must match exactly
export const isArrayTheSame = (arr, target) => [...arr, ...target].filter((item, index, currentArr) => currentArr.lastIndexOf(item) === currentArr.indexOf(item)).length === 0;


export const csvStrToArrayOfStr = (csvStr) => csvStr.includes(',') ? csvStr.split(',') : [csvStr];


export function csvStrToArrayOfNums(csvStr) {
  const arrayOfStrings = csvStrToArrayOfStr(csvStr);
  return arrayOfStrings.map(numAsStr => parseInt(numAsStr, 10));
}


// export function arrayOfNumsToCSVStr(arrayOfNUms){
//   return arrayOfNUms.join(',');
// }


export function shuffleArr(array, seed) {

  let currentIndex = array.length, temporaryValue, randomIndex;
  seed = seed || 1;
  let random = function() {
    const x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  };
  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(random() * currentIndex);
    currentIndex -= 1;
    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  // return array;
}


export async function fetchWithTimeout(resource, options ={}){

  const { timeout = 8000 } = options;

  const controller = new AbortController();
  const id = setTimeout(()=>controller.abort(), timeout);

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  });
  clearTimeout(id);

  return response;
}


export function scrollIntoView(ref){
  ref.current.scrollIntoView({
    behavior: 'smooth',
    block: 'end',
    inline: 'center'
  });
}


// Function to simulate a delay
// export function delay(time) {
//   return new Promise(resolve => setTimeout(resolve, time));
// }


export function extractFirstSearchParamValue(searchParams){
  // Early return if no search params
  if (!searchParams || Object.keys(searchParams).length === 0) return null;
  // Get the first parameter value, or directly use a specific parameter
  // if you know which one you need (e.g., searchParams.style)
  const value = Object.values(searchParams)[0];
  if (!value) return null;
  return value;
}


export function extractFirstSearchParamName(searchParams){
  // Early return if no search params
  if (!searchParams || Object.keys(searchParams).length === 0) return null;
  // Get the first parameter value, or directly use a specific parameter
  // if you know which one you need (e.g., searchParams.style)
  const value = Object.keys(searchParams)[0];
  if (!value) return null;
  return value;
}


/**
 * Finds the key corresponding to a value in any code set
 * @param {string} value - The value to find
 * @param {string} codeSetName - Optional parameter key (e.g., 'styles', 'mainColor')
 * @returns {string|null} - The key if found, null otherwise
 */
export function findKeyFromValue(value, codeSetName = 'styles') {

  // Get the appropriate code set based on the parameter key
  const codeSet = codeSetMapping[codeSetName];

  // If no code set is found, return null
  if (!codeSet) return null;

  // Find the key for the value in the code set
  return codeSet.getKeyByName(value);
}


// export function findKeyFromValue(value, codeSetName = 'styles') {
//   // Get the appropriate code set based on the parameter key
//   const codeSet = codeSetMapping[codeSetName];
//
//   // If no code set is found, return null
//   if (!codeSet) return null;
//
//   // Find the key for the value in the code set
//   return codeSet.getKeyByName(value);
// }
